export default __webpack_public_path__ + "static/media/portrait.e307aa32.webp";